/* eslint-disable react/jsx-no-bind */
import dynamic from 'next/dynamic'
import { CommonDataContext } from 'shared-components/contexts/CommonDataContext'
import { PopupContext } from 'shared-components/contexts/PopupContext'
import Burger from 'shared-svg/Burger.svg'
import Close from 'shared-svg/Close.svg'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import { prefetchHeaderNav } from 'lib/header-nav/use-header-nav'
import styles from 'shared-components/layout/MobileNavTrigger.module.css'
import localStyles from './MobileNavTrigger.module.css'

// SoundGuys-only drawer. Mirrors the shared MobileNavTrigger but injects the
// SoundGuys light redesign instead of the shared dark MobileNav.
const MobileNav = dynamic(() => import('components/nav/MobileNav'), { ssr: false })

/** Whether the open popup is this drawer (its class is one of ours) — the header asks,
 *  to lift itself above the popup layer only for the drawer, never a gallery. */
export const isDrawerPopup = (popupClassName: string | null): boolean => {
  if (!popupClassName) {
    return false
  }
  const classes = popupClassName.split(' ')
  return Object.values(localStyles).some(name => classes.includes(name))
}

interface MobileNavTriggerProps extends BasicStyledComponent {
  /** Only sizes the popup offset — with search off, the bar is one row shorter. */
  searchEnabled: boolean
}

const MobileNavTrigger: React.VFC<MobileNavTriggerProps> = ({ className, searchEnabled }) => {
  const { popupOpened, setPopupOpened, setPopupContent } = PopupContext.useContainer()
  const { common, showAdminPanel } = CommonDataContext.useContainer()

  return (
    <button
      aria-label="Show menu"
      type="button"
      className={clsx(styles.mobileNavButton, className)}
      // The drawer's accordions render counts from the header-nav document — start the
      // fetch while the finger is still travelling, before the dynamic import resolves.
      onPointerEnter={prefetchHeaderNav}
      onClick={() => {
        if (popupOpened) {
          setPopupOpened(false)
          return
        }

        prefetchHeaderNav()
        setPopupContent(
          <MobileNav common={common} onNavigate={() => setPopupOpened(false)} />,
          clsx(searchEnabled ? localStyles.popupClass : localStyles.popupNoSearch, {
            [searchEnabled ? localStyles.popupPreview : localStyles.popupPreviewNoSearch]:
              showAdminPanel,
          })
        )
        setPopupOpened(true)
      }}
    >
      {popupOpened ? (
        <Close className={styles.mobileNavIcon} />
      ) : (
        <Burger className={styles.mobileNavIcon} />
      )}
    </button>
  )
}

export default MobileNavTrigger
